import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import indsacmobilecrm from "../Images/indsac-mobile-crm.gif";

export default function ProductPlanning() {
  return (
    <>
      {/* <!-- Required meta tags --> */}
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta
        name="description"
        content="Mobile CRM can be defined as a CRM platform that has been specifically designed for mobile devices and tablets"
      />
      <meta property="og:title" content="Mobile CRM" />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content="https://entelipro.com/digitalmobile.jsp"
      />
      <meta
        property="og:image"
        content="https://www.entelipro.com/static/media/indsac-mobile-crm.gif"
      />
      <meta
        property="og:image:secure_url"
        content="https://www.entelipro.com/static/media/indsac-mobile-crm.gif"
      />
      <meta property="og:site_name" content="entelipro.com" />
      <meta
        property="og:description"
        content="Mobile CRM can be defined as a CRM platform that has been specifically designed for mobile devices and tablets"
      />
      <meta property="og:locale" content="en_US" />
      <title>Product Planning | Digital & Mobile :: entelipro.com</title>

      <script type="application/ld+json">
        `
        {`"@context":"https://schema.org","@type":"WebPage","name":"Mobile CRM",
                "logo":{"@type":"ImageObject","url":"https://www.entelipro.com/web/dist/img/u.png"},"url":"https://www.entelipro.com/digitalmobile"`}
        `
      </script>

      <Navbar />
      {/* <!-- breadcrumbs --> */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/services">
                  Services{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li>
                <Link to="/manufacturing">
                  Manufacturing{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>

              <li className="active">Product Planning</li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- breadcrumbs //--> */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsacmobilecrm}
                  alt="product"
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Product Planning </h4>
                <p className="para">
                  Production Planning is a critical component of the
                  Manufacturing module, responsible for scheduling and managing
                  the production process. It involves creating production
                  schedules based on customer orders, inventory levels, and
                  resource availability.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <h5>
                      {" "}
                      <a href="#"></a>
                    </h5>
                    <p className="para">
                      Flexibility is an essential requirement for most
                      professionals today due to the diverse working conditions,
                      including remote working, work from home, and more. 
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <h5>
                      <a href="#"></a>
                    </h5>
                    <p className="para">
                      With the help of mobile CRM, employees can have access to
                      important data irrespective of their location.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Here are some benefits of Product Planning</h3>
              <div className="row about-about">
                <div className="col-lg-4 col-md-6">
                  <div className="about-grids">
                    <h4>Optimized Resource Utilization</h4>
                    <p className="para">
                      : Ensures that manufacturing resources are used
                      efficiently, minimizing waste and downtime.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Reduced Lead Times</h4>

                    <p className="para">
                      {" "}
                      Helps in shortening production cycles, ensuring timely
                      delivery of finished products.
                      <br />
                      <br />
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4>Prevents Delays</h4>
                    <p className="para">
                      {" "}
                      Coordinates with Inventory Management and MRP to ensure
                      materials and resources are available when needed,
                      avoiding production bottlenecks.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 about-line-top">
                  <div className="about-grids">
                    <h4> Improved On-Time Delivery</h4>
                    <p className="para">
                      {" "}
                      Supports the completion of production runs within
                      scheduled timeframes, enhancing customer satisfaction.
                    </p>
                    <br />
                    <div className="mt-3 about-list"></div>
                  </div>
                </div>
              </div>
              <br />
              <br />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
